module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/social_media_logo-522d158086b5a7635364696659b1124b.jpg";